<template>
  <markdown-viewer :title="title" :markdown-content-raw="markdownContentRaw" />
</template>

<script>
import MarkdownViewer from './markdown-viewer.vue';
import projectTrackerMarkdown from './markdown_docs/projects.md?raw';

export default {
  name: 'ProjectTrackerGuidance',
  components: {
    MarkdownViewer,
  },
  data() {
    return {
      title: 'Tracking Projects in EDUKATE',
      markdownContentRaw: projectTrackerMarkdown,
    };
  },
};
</script>
